import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux';
import { AuthService as auth } from '../services/firebase/firebaseService';
import Swal from 'sweetalert2';
import { useIdleTimer } from 'react-idle-timer';


function AdminHeader() {
    const navigate = useNavigate();
    const location = useLocation();

    const user = useSelector(state => state.user.uid);

    async function signOut() {
        const { error } = await auth.signOut();

        if (error) {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: `Something happened loggin you out ${error.message} please try again`,
            });
        } else {
            Swal.fire({
                icon: 'success',
                title: 'Logged out',
            });
            navigate('./login');
        }
    }



    const handleOnActive = event => {
        // console.log('user is active', event);
        // console.log('time remaining', getRemainingTime());
    }

    const handleOnAction = (e) => {
        // console.log('user did something', e);
    }




    const handleOnIdle = async event => {
        console.log('last active', getLastActiveTime());
        const { error } = await auth.signOut();
        Swal.fire(
            'Timeout',
            'Due to inactivity you were redirected',
            'warning'
        )
        navigate('./login');
    }

    const { getLastActiveTime } = useIdleTimer({
        timeout: 1000 * 60 * 60,
        onIdle: handleOnIdle,
        onActive: handleOnActive,
        onAction: handleOnAction,
        debounce: 500,
    })


    // useEffect(() => {
    //   window.addEventListener('click', ()=>{
    //       setIsDropdownActive(prev => !prev);
    //   })
    // }, [])

    return (
        <header className="fixed" style={{ alignContent: 'center' }}>
            {/* {showBackButton && */}
            <div className="container-fluid">
                <div className="row  align-items-center">
                    <div className="col-md-4 mb-2 mb-md-0 text-dark text-decoration-none  col-sm-12 col-xs-12">
                        <a href="/" title="">
                            <img src={`${process.env.REACT_APP_API_URL}/images/garage-logo.png `} alt="logo" style={{ width: '100%' }} />
                        </a>
                    </div>
                    <div className="col-md-8 col-sm-12 col-xs-12 text-center">


                        {
                            user !== 'none' && user !== ''
                                ?

                                <nav>
                                    <ul>

                                        <li className='loginButton'><a href="#" className='Iconbig'><i className="la la-user "></i> <i className="la la-chevron-down "></i></a>
                                            <ul>
                                                <li> <Link to='/manage-users'><i className="las la-home "></i> <span> All Users</span></Link></li>
                                                <li> <Link to='/manage-garages'><i className="las la-home "></i> <span> Garages</span></Link></li>
                                                <li><Link to='/manage-advertisement' ><i className="la la-youtube "></i> <span> Advertisement</span></Link></li>
                                                <li><Link to='/zipcodes'><i className="la la-file "></i><span> Zipcodes</span></Link></li>
                                                <li><Link to='/change-password'><i className="la la-lock "></i><span>Change Password</span></Link></li>
                                                <li><Link onClick={signOut}  >
                                                    <i className="la la-sign-out "></i>
                                                    Sign Out</Link></li>
                                            </ul>
                                        </li>
                                    </ul>
                                </nav>
                                :
                                <Link to={'/login'} className="btn btn-primary"><i className="la la-user"></i>
                                    <b>Login</b>/<b>Sign Up</b></Link>
                        }


                        {/* 
                        <nav className="navbar navbar-expand-lg">
                            <ul className='navbar-nav align-items-center'>
                                <li className="nav-item"></li>
                                <li className="nav-item"></li>
                                <li className="nav-item"></li>
                                <li className="nav-item"></li>
                                <li className="nav-item">
                                    <a onClick={signOut} className='btn btn-primary text-white' >
                                        <i className='la la-sign-out-alt'></i>
                                        <span>Sign Out</span>
                                    </a></li>


                            </ul>
                        </nav> */}
                    </div>
                </div>
            </div>


        </header>

    );
};

export default AdminHeader;